(() => {
  const schemaElement = document.querySelector('script[data-product-schema]');
  if (!schemaElement) return;
  const productId = schemaElement.dataset.productSchema;
  const widget = document.querySelector(`[data-oke-widget][data-oke-reviews-product-id="shopify-${productId}"], [data-oke-reviews-widget-holder][data-oke-reviews-product-id="shopify-${productId}"]`);
  if (!widget) return;

  let productSchema;
  try {
    productSchema = JSON.parse(schemaElement.textContent);
  } catch {
    return;
  }

  const text = (root, selector) => root.querySelector(selector)?.textContent.trim() || '';
  const normalize = value => (value || '').replace(/\s+/g, ' ').trim();
  const publishedReviews = [...widget.querySelectorAll('script[data-oke-metafield-data]')].flatMap(element => {
    try {
      const data = JSON.parse(element.textContent);
      return Array.isArray(data.reviews) ? data.reviews : [];
    } catch {
      return [];
    }
  });
  let previousReviews = '';
  let scheduled = false;

  const updateReviews = () => {
    scheduled = false;
    const seen = new Set();
    const reviews = [];
    widget.querySelectorAll('.oke-w-review').forEach(element => {
      if (reviews.length === 1) return;
      const author = text(element, '.oke-w-reviewer-name');
      const ratingText = text(element, '.oke-reviewContent-stars .oke-a11yText');
      const values = ratingText.match(/\d+(?:[.,]\d+)?/g);
      const rating = values?.length === 2 ? Number(values[0].replace(',', '.')) : 0;
      const maximum = values?.length === 2 ? Number(values[1].replace(',', '.')) : 0;
      if (!author || !Number.isFinite(rating) || maximum !== 5 || rating < 1 || rating > maximum) return;

      const name = text(element, '.oke-reviewContent-title');
      const body = text(element, '.oke-reviewContent-body');
      const key = JSON.stringify([author, rating, name, body]);
      if (seen.has(key)) return;
      seen.add(key);
      const review = {
        '@type': 'Review',
        author: { '@type': 'Person', name: author },
        reviewRating: { '@type': 'Rating', ratingValue: rating, bestRating: maximum, worstRating: 1 }
      };
      if (name) review.name = name;
      if (body) review.reviewBody = body;
      const source = publishedReviews.find(review =>
        normalize(review.reviewer?.displayName) === normalize(author) &&
        Number(review.rating) === rating && normalize(review.title) === normalize(name) &&
        normalize(review.body) === normalize(body)
      );
      const date = element.querySelector('time[datetime]')?.getAttribute('datetime') || source?.dateCreated;
      if (date && /^\d{4}-\d{2}-\d{2}/.test(date) && !Number.isNaN(Date.parse(date))) review.datePublished = date;
      reviews.push(review);
    });

    if (!reviews.length) return;
    const serialized = JSON.stringify(reviews);
    if (serialized === previousReviews) return;
    previousReviews = serialized;
    schemaElement.textContent = JSON.stringify({ ...productSchema, review: reviews });
  };

  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateReviews);
  }).observe(widget, { childList: true, subtree: true, characterData: true });
  updateReviews();
})();
